export const UPDATE_ADMIN = "UPDATE_ADMIN";

export const updateAdmin = (value) => ({
  type: UPDATE_ADMIN,
  value,
});
